import { render, staticRenderFns } from "./innovativeEnterprise.vue?vue&type=template&id=4a199be7&scoped=true&"
import script from "./innovativeEnterprise.vue?vue&type=script&lang=js&"
export * from "./innovativeEnterprise.vue?vue&type=script&lang=js&"
import style0 from "./innovativeEnterprise.vue?vue&type=style&index=0&id=4a199be7&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a199be7",
  null
  
)

export default component.exports